var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { BaseBox } from '../../shared/Element';
import Image from '../../shared/Image';
export var ImageFit;
(function (ImageFit) {
    ImageFit["contain"] = "contain";
    ImageFit["cover"] = "cover";
    ImageFit["none"] = "none";
})(ImageFit || (ImageFit = {}));
var Wrap = styled(BaseBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  overflow: hidden;\n  border-radius: 50%;\n  border: 1px solid #D0D8DE;\n\n  ", " {\n    width: 100%;\n    height: 100%;\n    ", "\n  }\n"], ["\n  ", "\n  overflow: hidden;\n  border-radius: 50%;\n  border: 1px solid #D0D8DE;\n\n  ", " {\n    width: 100%;\n    height: 100%;\n    ", "\n  }\n"])), function (_a) {
    var size = _a.size;
    return "\n    width: " + size + ";\n    height: " + size + ";\n  ";
}, Image, function (_a) {
    var typeOfFit = _a.typeOfFit;
    return typeOfFit && "object-fit: " + typeOfFit + ";";
});
var ImagePreview = function (_a) {
    var _b = _a.src, src = _b === void 0 ? '' : _b, _c = _a.size, size = _c === void 0 ? '200px' : _c, props = __rest(_a, ["src", "size"]);
    return (React.createElement(Wrap, __assign({ size: size }, props),
        React.createElement(Image, { src: src, alt: "ImagePreview" })));
};
export default styled(ImagePreview)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2;
